import React, { useState } from 'react'

import Children from 'react-children-utilities'

const ReadAloud = (props) => {
    const [paused, setPaused] = useState(false)
    const [start, setStart] = useState(false)

    const msg = new SpeechSynthesisUtterance()

    const handlePlay = (msg) => {
        window.speechSynthesis.cancel()
        console.log(props.children);
        msg.text = Children.onlyText(props.children)
        setStart(true)
        window.speechSynthesis.speak(msg)
    }

    const handlePause = () => {
        setPaused(true)
        window.speechSynthesis.pause()
    }

    const handleResume = () => {
        setPaused(false)
        window.speechSynthesis.resume()
    }

    const handleCancel = () => {
        setStart(false)
        setPaused(false)
        window.speechSynthesis.cancel()
    }

    return (
        <div className='readAloud'>
            <div className="read-buttons" style={{display: "flex", alignItems: "center", marginTop: "3vh"}}>
                {!start ? <button style={{border: "none", background: "none"}} onClick={() => handlePlay(msg)}>
                <svg width="2vh" height="auto" viewBox="0 0 33 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.0527 17.9733C32.8962 19.1534 32.8962 21.8466 31.0527 23.0267L5.11735 39.6281C3.12054 40.9062 0.500002 39.4722 0.500002 37.1014L0.500003 3.89864C0.500004 1.52778 3.12054 0.0937729 5.11736 1.37195L31.0527 17.9733Z" fill="var(--logo)"/>
                </svg>
                </button> :
                paused ? <button style={{border: "none", background: "none"}} onClick={() => handleResume()}>
                <svg width="2vh" height="auto" viewBox="0 0 33 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.0527 17.9733C32.8962 19.1534 32.8962 21.8466 31.0527 23.0267L5.11735 39.6281C3.12054 40.9062 0.500002 39.4722 0.500002 37.1014L0.500003 3.89864C0.500004 1.52778 3.12054 0.0937729 5.11736 1.37195L31.0527 17.9733Z" fill="var(--logo)"/>
                </svg>
                </button>  : <button style={{border: "none", background: "none"}} onClick={() => handlePause()}>
                <svg width="2vh" height="auto" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 0L5 38" stroke="var(--logo)" stroke-width="9"/>
                <path d="M27 0L27 38" stroke="var(--logo)" stroke-width="9"/>
                </svg>
                </button> }
                <button style={{border: "none", background: "none"}} onClick={() => handleCancel()}>
                <svg width="2.5vh" height="auto" viewBox="0 0 39 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.8136 32.178C29.3876 32.5757 29.3876 33.4243 28.8136 33.822L20.3195 39.7068C19.6563 40.1663 18.75 39.6917 18.75 38.8849L18.75 27.1151C18.75 26.3083 19.6563 25.8337 20.3195 26.2931L28.8136 32.178Z" fill="var(--logo)"/>
                <path d="M35 19.2632C35 14.1754 31.8563 4 19.2817 4C6.70704 4 4.14563 14.3026 4 19.2632C4.00009 25.75 6.70704 33 19.2817 33" stroke="var(--logo)" stroke-width="7"/>
                </svg>
                </button> 
            </div>
            <div style={{fontSize: props.fontSize}}>{props.children}</div>
        </div>
    )
}

export default ReadAloud